var exports = {
  "_": "x61f99309--e32c60--tags",
};

module.exports = exports;
